import MobileSegment from './components/BoardingPassMob.css';

export default {
	MobileSegment
};
